import { ReactNode } from 'react';
import { ModelState } from './ModelState';
import { parseHtml } from './parseHtml';
import { equalsIgnoringCase } from './StringHelper';
import { Icon } from '../shared/Icon';

interface ValidationMessageProps {
    message?: string;
    children?: ReactNode;
    modelState?: ModelState;
    name?: string;
    alert?: boolean;
    className?: string;
}

export function ValidationMessage(props: ValidationMessageProps) {
    const { message, modelState, name, children, className } = props;
    let html = message;
    if (!message && modelState && name) {
        html = modelState[name] ?? modelState[Object.keys(modelState).find((key) => equalsIgnoringCase(key, name)) ?? ''];
    }

    if (!children && !html) {
        return null;
    }

    return props.alert ? (
        <div className={`alert alert-danger p-2 ${className}`} role="alert">
            {children ?? parseHtml(html)}
        </div>
    ) : (
        <div className={`form-text text-danger ${className}`}>
            <Icon name="exclamation-circle" className="mr-1" />
            {children ?? parseHtml(html)}
        </div>
    );
}
